import { ccfRoutes } from '@app/ccf/ccf-routes';
import { weightOptions } from '@app/ccf/options/weight-options';
import { WeightOptionEnum } from '@shared/api/types';
import Text from '@shared/components/content/text';
import InputFormField from '@shared/components/form/input-form-field';
import SelectFormField from '@shared/components/form/select-form-field';
import GuideTemplate from '@shared/components/guide-template';
import { FormLabel } from '@shared/components/ui/form';
import { useFormContext } from 'react-hook-form';
import {
  generatePath,
  useNavigate,
  useOutletContext,
  useParams,
} from 'react-router-dom';

export default function SupplyFlowAddWeightPage() {
  const { trigger, handleSubmit, watch } = useFormContext();
  const navigate = useNavigate();
  const { report_uuid } = useParams();
  const context: any = useOutletContext();

  const { onSubmit, isCreating, updateMode, supplyFlowUuid } = context;
  const selectedWeightOption = watch('weightOption');

  const onCompleteFlow = async () => {
    const isValid = await trigger();
    isValid && handleSubmit(onSubmit)();
  };

  return (
    <GuideTemplate
      preTitle="ADD SUPPLY FLOW"
      title="Add transported weight"
      description={
        <Text>
          The final step is to estimate how much of your goods, by weight, are
          distributed via this flow. We recommend estimating using a % of your
          total purchased goods, either food, packaging or both.
        </Text>
      }
      primaryActionText={updateMode ? 'Update flow' : 'Complete flow'}
      primaryActionProps={{
        onClick: onCompleteFlow,
        type: 'submit',
        loading: isCreating,
        disabled: isCreating,
      }}
      secondaryActionText="Back"
      secondaryActionProps={{
        onClick: () =>
          navigate(
            generatePath(ccfRoutes.SUPPLY_FLOW_REVIEW, {
              report_uuid: report_uuid,
              flow_uuid: supplyFlowUuid || '',
            })
          ),
        disabled: isCreating,
      }}
    >
      <form>
        <fieldset
          disabled={isCreating}
          className="flex w-full flex-col gap-6 text-left"
        >
          <div>
            <FormLabel className="text-left">
              How much of your goods are supplied via this flow?
            </FormLabel>
            <div className="mt-2 flex items-center gap-2">
              <InputFormField
                name="weight"
                type="number"
                min={1}
                max={
                  selectedWeightOption !== WeightOptionEnum['total_weight']
                    ? 100
                    : undefined
                }
                step={0.1}
                className="w-32"
              />
              <SelectFormField
                name="weightOption"
                options={weightOptions}
                placeholder="Select unit"
                className="w-full"
              />
            </div>
          </div>
          <div>
            <FormLabel className="text-left">
              What percentage of this flow requires cold-chain distribution?
            </FormLabel>
            <InputFormField
              name="coldChainPercentage"
              type="number"
              min={1}
              max={100}
              step={0.1}
              className="mt-2 w-24"
              adornmentRight="%"
            />
          </div>
        </fieldset>
      </form>
    </GuideTemplate>
  );
}
